import { Link } from "react-router-dom";

const stats = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "480+", label: "明星资料档案" },
  { value: "60+", label: "精选策划专题" },
  { value: "每日", label: "更新最新内容" },
];

export default function SiteIntro() {
  return (
    <div className="grid grid-cols-1 gap-8 rounded-lg bg-primary-950 p-6 md:grid-cols-2 md:items-center md:p-10">
      <div>
        <span className="font-display text-xs tracking-[0.3em] text-primary-300">ABOUT US</span>
        <h2 className="mt-3 text-2xl font-black text-background-50 md:text-3xl">
          发现每一部值得看的激情影视
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
          激情视频是一个专注激情题材影视剧与精彩视频内容的综合推荐平台。我们聚合最新上映的影视剧与网络剧集，提供详尽的剧情介绍、演员资料与观众评论，帮助你用更少的时间，找到真正打动你的作品。
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            浏览全部影视
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-lg bg-primary-900/70 p-5">
            <p className="font-display text-2xl font-bold text-accent-400 md:text-3xl">{s.value}</p>
            <p className="mt-1 text-sm text-background-300">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}